/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import _map from 'lodash/map'

// 【盲盒详情页】 http://wiki.xunlei.cn/pages/viewpage.action?pageId=138970799
export const blind_gift_homepage = createAsyncThunk(
  '/live/gift/blind_gift_homepage',
  async (p: any, store: any) => {
    const resp = await http.post('/live/gift/blind_gift_homepage', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

export interface Iblind_gift {
  gift_id: number
  icon: string
  coin: number
  name: string
}
export interface Igift_list {
  gift_id: number
  icon: string
  coin: number
  senior: boolean // 是否高级礼物
  name: string
  count: number // 爆奖个数
}
export interface IBlindGiftItem {
  blind_gift: Iblind_gift
  gift_list: Igift_list[]
  probability_list: string[]
}

const initialState: {
  list?: IBlindGiftItem[]
} = {}

export const BlindBoxDetailSlice = createSlice({
  name: 'BlindBoxDetail',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(blind_gift_homepage.fulfilled, (state, action) => {
      Object.assign(state, {list: action.payload?.list || []})
    })
  },
})

export const useBlindBoxDetail = () =>
  useSelector((store) => store.BlindBoxDetail)

export default BlindBoxDetailSlice.reducer
export const BlindBoxDetailActions = BlindBoxDetailSlice.actions
